export default __webpack_public_path__ + "static/kv-1-f42ce4ecc541850a36ff098065297a8a.png";